import React from 'react';
import { Link } from 'react-router-dom';
import './ABCDMoney.css';

const ABCDMoney = () => {
  const blogs = [
    {
      id: 1,
      category: 'FINANCING SOLUTIONS',
      categoryColor: '#f5a623',
      title: 'What Is Khasra Number',
      date: '1 July 2026',
      borderColor: '#f5a623',
      link: '/blog/what-is-khasra-number'
    },
    {
      id: 2,
      category: 'FINANCING SOLUTIONS',
      categoryColor: '#8bc34a',
      title: 'Registered Mortgage vs Equitable Mortgage',
      date: '1 July 2026',
      borderColor: '#8bc34a',
      link: '/blog/registered-mortgage-vs-equitable-mortgage'
    },
    {
      id: 3,
      category: 'FINANCING SOLUTIONS',
      categoryColor: '#f5a623',
      title: 'Builder Buyer Agreement: Meaning, Key Clauses &...',
      date: '07 January 2026',
      borderColor: '#f5a623',
      link: '/blog/builder-buyer-agreement'
    },
    {
      id: 4,
      category: 'FINANCING SOLUTIONS',
      categoryColor: '#8bc34a',
      title: 'Difference Between Loan Write-Off and Loan Waive...',
      date: '06 January 2026',
      borderColor: '#8bc34a',
      link: '/blog/loan-write-off-waiver'
    }
  ];

  return (
    <section id="abcd-money" className="abcd-money-section">
      <div className="abcd-container">
        <div className="section-header-row">
          <h2 className="stories-title">
            ABCD Of <span className="title-highlight">Money</span>
          </h2>

        </div>

        <div className="blogs-grid">
          {blogs.map((blog) => (
            <Link key={blog.id} to={blog.link} className="blog-card-link">
              <div className="blog-card">
                <div className="blog-content">
                  <span
                    className="blog-category"
                    style={{ backgroundColor: blog.categoryColor }}
                  >
                    {blog.category}
                  </span>
                  <h3 className="blog-title">{blog.title}</h3>
                  <p className="blog-date">{blog.date}</p>
                </div>
                <div
                  className="blog-footer"
                  style={{ backgroundColor: blog.borderColor }}
                ></div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ABCDMoney;
